<template>
  <div class="our-client">
    <HeaderStyles1>
      <h1 slot="title" v-html="$t('our-client-head-h1')"></h1>
      <p slot="detail" v-html="$t('our-client-head-small')"></p>
      <b-img class="platform-title-img" slot="image" src="../assets/imgs/head-img-smart-construction.png" alt="" />
    </HeaderStyles1>

    <b-container>
      <h1 class="section-title">{{$t('our-client-section-1-title')}}</h1>
      <b-row>
        <b-col class="mb-5" @click="linkTo('https://www.scmp.com/business/banking-finance/article/3086673/how-local-start-used-location-tracking-and-geofencing-tech')" cols="12" xl="4" md="4" sm="6">
          <div class="card">
            <div class="img mask">
              <b-img class="img-head" src="../assets/imgs/our-client-feedback-img-1.png"></b-img>
            </div>
            <div class="show-calendar">
              <img src="../assets/imgs/icon-calendar.png" />
              <span>10 FEB 2018</span>
            </div>
            <p>How a local start-up used location tracking and geofencing tech developed for retailers to help Hong Kong control the spread of coronavirus</p>
            <b-button variant="link">Read More</b-button>
          </div>
        </b-col>
        <b-col class="mb-5" @click="linkTo('https://asia.nikkei.com/Business/Business-trends/Coronavirus-tracking-apps-Tech-firms-see-opportunities-in-Asia')" cols="12" xl="4" md="4" sm="6">
          <div class="card">
            <div class="img mask">
              <b-img class="img-head" src="../assets/imgs/our-client-feedback-img-2.png"></b-img>
            </div>
            <div class="show-calendar">
              <img src="../assets/imgs/icon-calendar.png" />
              <span>10 FEB 2018</span>
            </div>
            <p>How a local start-up used location tracking and geofencing tech developed for retailers to help Hong Kong control the spread of coronavirus</p>
            <b-button variant="link">Read More</b-button>
          </div>
        </b-col>
        <b-col class="mb-5" @click="linkTo('https://asia.nikkei.com/Spotlight/Comment/Hong-Kong-startup-s-tracing-app-keeps-coronavirus-in-check')" cols="12" xl="4" md="4" sm="6">
          <div class="card">
            <div class="img mask">
              <b-img class="img-head" src="../assets/imgs/our-client-feedback-img-3.png"></b-img>
            </div>
            <div class="show-calendar">
              <img src="../assets/imgs/icon-calendar.png" />
              <span>10 FEB 2018</span>
            </div>
            <p>How a local start-up used location tracking and geofencing tech developed for retailers to help Hong Kong control the spread of coronavirus</p>
            <b-button variant="link">Read More</b-button>
          </div>
        </b-col>
        <b-col class="mb-5" @click="linkTo('https://www.scmp.com/business/companies/article/3081731/hong-kongs-fx-interventions-lower-key-interest-rate-lifting')" cols="12" xl="4" md="4" sm="6">
          <div class="card">
            <div class="img mask">
              <b-img class="img-head" src="../assets/imgs/our-client-feedback-img-1.png"></b-img>
            </div>
            <div class="show-calendar">
              <img src="../assets/imgs/icon-calendar.png" />
              <span>10 FEB 2018</span>
            </div>
            <p>How a local start-up used location tracking and geofencing tech developed for retailers to help Hong Kong control the spread of coronavirus</p>
            <b-button variant="link">Read More</b-button>
          </div>
        </b-col>
        <b-col class="mb-5" @click="linkTo('https://www.scmp.com/business/banking-finance/article/2157198/hong-kong-prepares-usher-virtual-banks-60-firms-apply-be')" cols="12" xl="4" md="4" sm="6">
          <div class="card">
            <div class="img mask">
              <b-img class="img-head" src="../assets/imgs/our-client-feedback-img-2.png"></b-img>
            </div>
            <div class="show-calendar">
              <img src="../assets/imgs/icon-calendar.png" />
              <span>10 FEB 2018</span>
            </div>
            <p>How a local start-up used location tracking and geofencing tech developed for retailers to help Hong Kong control the spread of coronavirus</p>
            <b-button variant="link">Read More</b-button>
          </div>
        </b-col>
        <b-col class="mb-5" @click="linkTo('https://news.mingpao.com/pns/%E6%B8%AF%E8%81%9E/article/20180625/s00002/1529864610970/%E6%B8%AF%E5%88%9D%E5%89%B5%E8%A6%B7%E6%BA%96%E9%9B%B6%E5%94%AE%E5%95%86%E9%9C%80%E6%B1%82-%E9%9B%BB%E5%AD%90%E5%83%B9%E9%8C%A2%E7%89%8C%E8%B6%85%E8%B6%8A%E9%BB%91%E7%99%BD%E9%9D%9C%E6%AD%A2')" cols="12" xl="4" md="4" sm="6">
          <div class="card">
            <div class="img mask">
              <b-img class="img-head" src="../assets/imgs/our-client-feedback-img-3.png"></b-img>
            </div>
            <div class="show-calendar">
              <img src="../assets/imgs/icon-calendar.png" />
              <span>10 FEB 2018</span>
            </div>
            <p>How a local start-up used location tracking and geofencing tech developed for retailers to help Hong Kong control the spread of coronavirus</p>
            <b-button variant="link">Read More</b-button>
          </div>
        </b-col>
      </b-row>

      <h1 class="section-title">{{$t('our-client-section-2-title')}}</h1>
      <b-row>
        <b-col class="mb-5" cols="12" xl="4" md="4" sm="6">
          <div class="card user-case-card">
            <div class="img">
              <b-img class="img-head-contain" src="../assets/imgs/compny-1.png"></b-img>
            </div>
            <p>Collection with gift on which until accounts</p>
          </div>
        </b-col>
        <b-col class="mb-5" cols="12" xl="4" md="4" sm="6">
          <div class="card user-case-card">
            <div class="img">
              <b-img class="img-head-contain" src="../assets/imgs/compny-2.png"></b-img>
            </div>
            <p>Collection with gift on which until accounts</p>
          </div>
        </b-col>
        <b-col class="mb-5" cols="12" xl="4" md="4" sm="6">
          <div class="card user-case-card">
            <div class="img">
              <b-img class="img-head-contain" src="../assets/imgs/compny-3.png"></b-img>
            </div>
            <p>Collection with gift on which until accounts</p>
          </div>
        </b-col>
        <b-col class="mb-5" cols="12" xl="4" md="4" sm="6">
          <div class="card user-case-card">
            <div class="img">
              <b-img class="img-head-contain" src="../assets/imgs/compny-4.png"></b-img>
            </div>
            <p>Collection with gift on which until accounts</p>
          </div>
        </b-col>
        <b-col class="mb-5" cols="12" xl="4" md="4" sm="6">
          <div class="card user-case-card">
            <div class="img">
              <b-img class="img-head-contain" src="../assets/imgs/compny-5.png"></b-img>
            </div>
            <p>Collection with gift on which until accounts</p>
          </div>
        </b-col>
        <b-col class="mb-5" cols="12" xl="4" md="4" sm="6">
          <div class="card user-case-card">
            <div class="img">
              <b-img class="img-head-contain" src="../assets/imgs/compny-6.png"></b-img>
            </div>
            <p>Collection with gift on which until accounts</p>
          </div>
        </b-col>
        <b-col class="mb-5" cols="12" xl="4" md="4" sm="6">
          <div class="card user-case-card">
            <div class="img">
              <b-img class="img-head-contain" src="../assets/imgs/compny-7.png"></b-img>
            </div>
            <p>Collection with gift on which until accounts</p>
          </div>
        </b-col>
        <b-col class="mb-5" cols="12" xl="4" md="4" sm="6">
          <div class="card user-case-card">
            <div class="img">
              <b-img class="img-head-contain" src="../assets/imgs/compny-8.png"></b-img>
            </div>
            <p>Collection with gift on which until accounts</p>
          </div>
        </b-col>
        <b-col class="mb-5" cols="12" xl="4" md="4" sm="6">
          <div class="card user-case-card">
            <div class="img">
              <b-img class="img-head-contain" src="../assets/imgs/compny-9.png"></b-img>
            </div>
            <p>Collection with gift on which until accounts</p>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import HeaderStyles1 from '../components/HeaderStyles1.vue'
import runtime from '../utils/runtime'

export default {
  name: 'Our Client',
  components: {
    HeaderStyles1
  },
  data () {
    return {
      isMobile: runtime.isMobile()
    }
  },
  methods: {
    linkTo (url) {
      window.location.href = url
    }
  }
}
</script>
<style lang="scss" scoped>
  .our-client {
    .platform-title-img {
      width: 50%;
      bottom: 30px;
      right: 30px;
    }

    .section-title {
      font-size: 50px;
      font-weight: bold;
      margin-top: 60px;
      margin-bottom: 40px;
    }

    .card {
      box-shadow: 0px 3px 31px 0px rgba(0,0,0,0.16);
      transition: all .3s ease-out;

      &:hover {
        box-shadow: 0px 3px 31px 0px rgba(0,0,0,0.3);
        cursor: pointer;
      }

      .img {
        position: relative;
        .img-head {
          height: 250px;
          object-fit: cover;
          width: 100%;
        }
        .img-head-contain {
          height: 270px;
          object-fit: contain;
          width: 100%;
          border: 1px solid #999999;
        }
        &.mask:before {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          z-index: 5;
          background-color: rgba(190, 112, 255, 0.3);
        }
      }
      .show-calendar {
        display: flex;
        font-size: 16px;
        margin: 15px;

        img {
          width: 18px;
          margin-right: 10px;
          align-self: center;
        }
      }
      p {
        font-size: 20px;
        font-weight: bold;
        padding: 0 15px;
        line-height: 1.2;
      }
      button {
        text-align: left;
        outline: none;
        text-underline: none;

        &:focus {
          box-shadow: none;
          text-underline: none;
        }
      }

      &.user-case-card {
        .img {
          position: relative;
          .img-head {
            height: 270px;
          }
        }
        p {
          padding: 30px 15px;
        }
      }
    }
  }
</style>
